"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.editorState = exports.selection = exports.row = exports.editing = exports.coordinate = exports.column = exports.cellMode = exports.additionalColumns = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var additionalColumns = _propTypes.default.oneOf(['allow', 'disallow', 'ignore']);

exports.additionalColumns = additionalColumns;
var cellMode = _propTypes.default.number;
exports.cellMode = cellMode;
var column = _propTypes.default.string;
exports.column = column;

var coordinate = _propTypes.default.shape({
  x: _propTypes.default.number.isRequired,
  y: _propTypes.default.number.isRequired
});

exports.coordinate = coordinate;

var editing = _propTypes.default.shape({
  value: _propTypes.default.any
});

exports.editing = editing;

var row = _propTypes.default.objectOf(_propTypes.default.any);

exports.row = row;

var selection = _propTypes.default.shape({
  left: _propTypes.default.number.isRequired,
  right: _propTypes.default.number.isRequired,
  top: _propTypes.default.number.isRequired,
  bottom: _propTypes.default.number.isRequired,
  activeX: _propTypes.default.number.isRequired,
  activeY: _propTypes.default.number.isRequired
});

exports.selection = selection;

var editorState = _propTypes.default.shape({
  columns: _propTypes.default.arrayOf(column).isRequired,
  editing: editing.isRequired,
  rows: _propTypes.default.arrayOf(row).isRequired,
  selection: selection
});

exports.editorState = editorState;